export const _ADD               = "h9psJvK6TwntqzvCMAdiGw==";
export const _EDIT              = "0spBf5ZvMQx3GkjbJhVfkQ==";
export const _VIEW              = "qIpkVKBvPoJNv7GotE7IWA==";
export const _DELETE            = "NKENEOAsnAj8R3E2mNFhpBvRfsreNfnrnUdQp7karV8=";
export const _RECOVER           = "CZCNWjIHRPS4l+d5v81HgRXP/iQUVkCb65dDBvFXA4E=";
export const _LIST              = "WzKxsHkKItbaZn0zVpvaYw==";
export const _TRASH             = "xPBQl2EDoXHas/rYYCKWJuOADD40+fqWy5jrwGuMs+0=";